// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__9ou9U","info":"Note_info__xi6Dc","note":"Note_note__18fHD","actions":"Note_actions__ZwnDT"};